import { Trans, useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import { MdCheck } from 'react-icons/md';
import * as S from './styles';

const FacialRegisteredContent = ({
  facialPhoto,
  userName,
  textColor,
  onOpenEditModal,
  isLoadingPhoto,
}) => {
  const [t] = useTranslation('personalized-invite');

  const handleClick = () => {
    if (onOpenEditModal) {
      onOpenEditModal();
    }
  };

  return (
    <>
      <S.FacialPhotoWrapper $textColor={textColor}>
        <S.FacialCheck onClick={handleClick}>
          {!facialPhoto || isLoadingPhoto ? <S.FacialPhotoSkeleton /> : null}
          {facialPhoto && (
            <>
              <S.FacialPhoto src={facialPhoto} alt={userName} />
              <S.CheckBadge>
                <MdCheck />
              </S.CheckBadge>
            </>
          )}
        </S.FacialCheck>
      </S.FacialPhotoWrapper>
      <S.Content>
        <S.WelcomeText $textColor={textColor}>
          {userName
            ? t('edit-mode.greeting', { userName })
            : t('edit-mode.greeting-no-name')}
        </S.WelcomeText>
        <S.UpdatePrompt $textColor={textColor} onClick={handleClick}>
          <Trans>{t('edit-mode.update-prompt')}</Trans>
        </S.UpdatePrompt>
      </S.Content>
    </>
  );
};

FacialRegisteredContent.propTypes = {
  facialPhoto: propTypes.string,
  userName: propTypes.string,
  textColor: propTypes.string,
  onOpenEditModal: propTypes.func,
  isLoadingPhoto: propTypes.bool,
};

FacialRegisteredContent.defaultProps = {
  facialPhoto: '',
  userName: '',
  textColor: undefined,
  onOpenEditModal: () => {},
  isLoadingPhoto: false,
};

export default FacialRegisteredContent;
